export const LATEST_VERSION = '1.1';

export enum criterionStep {
    START = 0,
    AFTER_UPLOAD = 1,
    AFTER_CONSTRAINTS = 2,
    AFTER_RECLASSIFICATION = 3
}
